import React, { ReactNode } from "react";
import "./full-width-cta.scss";
import { ReactRouterLink as Link } from "@thrivetribe/mvf.ui.atoms.react-router-link";

export type FullWidthCtaProps = {
  children: ReactNode;
  reactRouterTo?: string;
  target?: React.HTMLAttributeAnchorTarget;
};

export const FullWidthCta: React.FC<FullWidthCtaProps> = ({
  children,
  reactRouterTo,
  target = "_self",
}: FullWidthCtaProps) => {
  if (reactRouterTo === undefined) {
    return <div className="full-width-cta">{children}</div>;
  }

  return (
    <Link to={reactRouterTo} className="full-width-cta" target={target}>
      {children}
    </Link>
  );
};
